import React from "react"
import { useGetCallTypesQuery } from "../../features/operator-report/service.ts"

interface CallTypeFilterProps {
  callTypeId: string
  onCallTypeChange: (callTypeId: number) => void
  operatorId?: number
  departmentId: number
}

export const CallTypeFilter: React.FC<CallTypeFilterProps> = ({
  callTypeId,
  onCallTypeChange,
  operatorId,
  departmentId,
}) => {
  const { data: callTypes } = useGetCallTypesQuery({
    operatorId,
    departmentId,
  })

  return (
    <div className="form-control flex-1 max-w-xs">
      <label htmlFor="callType" className="label">
        <span className="label-text">Тип звонка</span>
      </label>
      <select
        id="callType"
        name="callType"
        className="select select-bordered"
        value={callTypeId}
        onChange={e => onCallTypeChange(+e.target.value)}
      >
        <option value="">Все</option>
        {callTypes?.map(callType => (
          <option key={callType.id} value={callType.id}>
            {callType.title}
          </option>
        ))}
      </select>
    </div>
  )
}
